import React from 'react';

import ControlledNumericValueEditor from 'schemas/tags/ControlledNumericValueEditor';
import {ElementKeyboardEvent} from 'util/Types';

export interface ControlledFloatValueEditorProps {
  defaultValue?: {value?: string | number | null} | null;
  placeholder?: string;
  autoFocus: boolean;
  onChange: (tag: {floatValue: string | number; value: string | null}) => void;
  value?: string | number | null;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
}

export default function ControlledFloatValueEditor(props: ControlledFloatValueEditorProps): JSX.Element {
  return (
    <ControlledNumericValueEditor
      {...props}
      valueAccessorKey="floatValue"
      useStringValue={true}
      placeholder={props.placeholder ?? 'Floating Point Value'}
    />
  );
}
